module.exports = __webpack_public_path__ + "img/fctimg03@2x_wps.3396a6c0.png";